import React from 'react';

import { Col, Row, UncontrolledTooltip } from 'reactstrap';
import { quadroKanbanEnum } from '@common/util/defaultValues';
import Paragrafo from './Paragrafo';
import { useIntl } from 'react-intl';
import IntlMessage from '../../../../helpers/intlMessage';

function CardBloco({
	id,
	label,
	material,
	item,
	icone,
	etapa,
	openModal,
	imprimirEtiquetaIndividual,
	openModalBlocos,
	setState
}) {
	const intl = useIntl()
	return (
		<Row>
			<Col>
				<p style={{ fontSize: '16px', fontWeight: 600, marginBottom: '2px' }}>
					{label}
				</p>
				<Paragrafo
					id={`material_${id}`}
					title={etapa === quadroKanbanEnum.HL_BLOCOS.id ? <IntlMessage id='dashboards.reports.material' /> : <IntlMessage id='dashboards.reports.type' />}
					text={material}
				/>

				<p
					id={`paciente_${id}`}
					style={{ fontSize: '14px', marginBottom: '2px' }}
				>
					<strong><IntlMessage id='dashboards.disposalMaterials.patient' />: </strong>
					{item.nomePaciente}
					<UncontrolledTooltip placement='top' target={`paciente_${id}`}>
						{item.nomePaciente}
					</UncontrolledTooltip>
				</p>
				{item.pacienteNomeSocial &&
					<p
						id={`nomesocial_${id}`}
						style={{ fontSize: '14px', marginBottom: '2px' }}
					>
						<strong><IntlMessage id='dashboards.general.socialName' />: </strong>
						{item.pacienteNomeSocial}
						<UncontrolledTooltip placement='top' target={`nomesocial_${id}`}>
							{item.pacienteNomeSocial}
						</UncontrolledTooltip>
					</p>}
				<Paragrafo
					id={`coloracao_${id}`}
					title={`${intl.formatMessage({ id: 'dashboards.examDetail.table.coloring' })}`}
					text={item.coloracao}
				/>
				{item.complemento &&
						<p
							id={`complemento_${id}`}
							style={{ fontSize: '14px', marginBottom: '2px', width: '80%' ,  whiteSpace: 'no-wrap', overflow: 'hidden', textOverflow: 'ellipsis' }}
							title={item.complemento}
						>
							<strong><IntlMessage id="dashboards.examDetail.table.complement" /></strong>
							{/* {`: ${item.complemento.length > 27 ? item.complemento.slice(0, 27) + '...' : item.complemento}`} */}
							{`: ${item.complemento}`}
						</p>
				}
			</Col>
			<div className="menu-right">
				<div>
				<br></br>
						{(item.nConformidade === 'S' || item.existeNConformidade < 2) && (
							<div >
								<p
									id={`nao_conformidade${item.id}`}
									style={{ fontSize: '9px', marginBottom: '5px', marginTop: '5px' }}
									className='badge badge-danger nao-conformidade'
								>
									<IntlMessage id='dashboards.general.nonCompliance' />
								</p>
							</div>
						)}
					<p
						id={`data_atualizacao_${id}`}
						style={{ fontSize: '10px', marginBottom: '15px' }}
						className="badge badge-info"
					>
						{item.dataAtualizacao}
					</p>
					<UncontrolledTooltip
						placement="top"
						target={`data_atualizacao_${id}`}
					>
						{`${intl.formatMessage({ id: 'dashboards.cytology.updateDate' })}`}
					</UncontrolledTooltip>

					<div className="menu-card-right">
						<i
							onClick={() => imprimirEtiquetaIndividual(item)}
							aria-hidden="true"
							style={{ marginRight: '8px' }}
							className="mv-basico-codigo_barras"
							role="button"
						/>
						{/* ANATOWEB-3505 */}
						{etapa !== quadroKanbanEnum.HL_BLOCOS.id && (
							<i
								onClick={() => openModal(id, etapa, 'cancelar')}
								aria-hidden="true"
								style={{ marginRight: '8px' }}
								className="fas fa-trash-alt"
								title={`${intl.formatMessage({ id: 'dashboards.examDetails.cancel' })}`}
								role="button"
							/>
						)}
						<i
							onClick={() => openModal(id, etapa, 'naoconformidade')}
							aria-hidden="true"
							className="fas fa-exclamation-circle"
							style={{ color: `${item.nConformidade === 'S' || item.existeNConformidade<2 ? 'red' : ''}` }}
							title={`${intl.formatMessage({ id: 'dashboards.general.nonCompliance' })}`}
							role="button"
						/>
					</div>
					<i
						className={`${icone} fa-2x`}
						style={{
							marginRight: '8px',
							color: '#3076a8',
							fontSize: '1.5em',
						}}
					/>
					<i
						className='fas fa-pen'
						style={{
							color: '#3076a8',
							fontSize: '0.5rem'
						}}
						onClick={() => {/*
							console.log(lamina)
							console.log(this.state.laminaSelecionada)
							this.botaoEditarLamina() */
							setState({
								blocoSelecionado: item
							})
							console.log(item)
							openModalBlocos();
						}}
					></i>
				</div>
			</div>
		</Row>
	);
}

export default CardBloco;



// WEBPACK FOOTER //
// ./src/pages/histologia/laminas/Card/index.jsx